const validateAnswer = function (errors, vm, showTip) {
  let emptyIndex = 0
  const { optionList, descList, descIndex, answerConfig: { requireInd, otherRequireInd } } = this
  const crtDescIndex = descIndex // vm.crtDescIndex

  if (!descList[crtDescIndex].visibility) {
    return true
  }
  if (requireInd === '1') {
    if (descList.every((item, index) => {
      // && item.visibility 如果为false 不必填
      return !item.value
    })) {
      errors.push(vm.cvtLang('tipAnswerNull', vm.surveyInfoLang.tipAnswerNull))
      return !errors.length
    }
  }

  if (descList.every((item, index) => {
    return !item.value
  })) {
    return !errors.length
  }

  if (descList.some((desc, index) => {
    const { value } = desc
    if (!value || !value.length) {
      emptyIndex = index
      return true
    } else {
      // 其他请注明
      const otherItem = optionList.find(item => value === item.id && item.type === 'other')
      if (otherItem && otherRequireInd === '1' && !otherItem.otherValue) {
        emptyIndex = index
        return true
      }
    }
  })) {
    if (emptyIndex === crtDescIndex) {
      errors.push(vm.cvtLang('tipAnswerNull', vm.surveyInfoLang.tipAnswerNull))
    }
  }
  return !errors.length
}

const validate = function (vm, showTip) {
  const errors = []
  return {
    result: validateAnswer.call(this, errors, vm, showTip),
    errors
  }
}

const answerValidate = {
  validateAnswer,
  validate
}

export default answerValidate



// WEBPACK FOOTER //
// ./src/components/editor/RadioBoxGroup/answerValidate.js